export default __webpack_public_path__ + "static/media/avatar.25adf4ba.png";